import {
    ChainInfo,
    GalaxyStationController,
    KeplrController,
    LUNCDashController,
    StationController,
    WalletController,
    WalletName,
    WalletType,
    CosmostationController
  } from "@goblinhunt/cosmes/wallet";
  import { CHAINS, DENOM, GAS_PRICE, RPC_URLS, WC_PROJECT_ID } from "@constant/constant";
  
  const WALLET_SETTINGS: Record<
    string,
    { controller: WalletController; name: string }
  > = {
    [WalletName.STATION]: {
      controller: new StationController(),
      name: "Station",
    },
    [WalletName.KEPLR]: {
      controller: new KeplrController(WC_PROJECT_ID),
      name: "Keplr",
    },
    [WalletName.GALAXYSTATION]: {
      controller: new GalaxyStationController(WC_PROJECT_ID),
      name: "Galaxy",
    },
    [WalletName.LUNCDASH]: {   
      controller: new LUNCDashController(),
      name: "Luncdash",
    },
    [WalletName.COSMOSTATION]: {   
      controller: new CosmostationController(WC_PROJECT_ID),
      name: "Cosmostation",
    },
  }; 
  
  export class WalletSupport {
    private _controller: WalletController;
  
    constructor(private _name: WalletName, private _type: WalletType) {
      this._controller = WALLET_SETTINGS[_name].controller;
    }
  
    get controller() {
      return this._controller;
    }
  
    get type() {
      return this._type;
    }
  
    get name() {
      return WALLET_SETTINGS[this._name].name;
    }
  
    get walletName() {
      return this._name;
    }
  
    async connect(chain: CHAINS) {
      const chainInfo: ChainInfo<string> = {
        chainId: chain,
        gasPrice: {
          amount: GAS_PRICE,
          denom: DENOM,
        },
        rpc: RPC_URLS[chain],
      };
      const result = await this._controller.connect(this._type, [chainInfo]);
      return result.get(chain);
    }
  }
  
  export const SUPPORTED_WALLETS = [
    new WalletSupport(WalletName.STATION, WalletType.EXTENSION),
    new WalletSupport(WalletName.STATION, WalletType.WALLETCONNECT),
    new WalletSupport(WalletName.KEPLR, WalletType.EXTENSION),
    new WalletSupport(WalletName.KEPLR, WalletType.WALLETCONNECT),
    new WalletSupport(WalletName.GALAXYSTATION, WalletType.EXTENSION),
    // new WalletSupport(WalletName.GALAXYSTATION, WalletType.WALLETCONNECT),
    new WalletSupport(WalletName.LUNCDASH, WalletType.WALLETCONNECT),
    new WalletSupport(WalletName.COSMOSTATION, WalletType.EXTENSION),
    new WalletSupport(WalletName.COSMOSTATION, WalletType.WALLETCONNECT),
  ];
  